import useMultpleTable from '../../../hooks/useMultipleTable';
import { Table } from '../../Table';
import { MultiTableComponentProps } from '../types';

const columnLables = {
  exposure_value: {
    name: 'Value of exposure'
  },
  bic_code: {
    name: "Controlled structure's BIC"
  },
  lei_code: {
    name: "Controlled structure's LEI"
  },
  name: {
    name: "Controlled structure's name"
  }
};

export function ControlledStucture({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  onAddColumn,
  onDeleteColumn,
  isMultiFunds
}: MultiTableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useMultpleTable({
    data: funds[currentDataKey]?.fund_data?.CONTROLLED_STRUCTURE,
    onChangeFund,
    schema: schema.CONTROLLED_STRUCTURE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.CONTROLLED_STRUCTURE?.field_names || [],
    columnLables,
    onAddColumn,
    onDeleteColumn,
    tableName: 'CONTROLLED_STRUCTURE',
    order: 232 as any,
    isMultiFunds,
    funds
  });

  return (
    <Table
      id="fca-reporttables-controlled-structure-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
